import ViewPadrao from "../views/ViewPadrao";
import SubGrupoItemList from "../views/SubGrupoItemList";
import SubGrupoItemCad from "../views/SubGrupoItemCad";

export default {
  path: "sub-grupo-item",
  component: ViewPadrao,
  children: [
    {
      path: "lista",
      name: "sub-grupo-item-list",
      component: SubGrupoItemList
    },
    {
      path: "novo",
      name: "sub-grupo-item-formulario",
      component: SubGrupoItemCad
    },
    {
      path: "editar/:id",
      name: "sub-grupo-item-formulario-editar",
      component: SubGrupoItemCad
    }
  ]
};
